(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {

  constructor() {
    super();
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }

  connectedCallback() {

    this.header = document.querySelector('.section-header');

    this.mobileMediaQuery =
      window.matchMedia('(max-width: 990px)');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always';

    this.headerBounds = {};

    this.setHeaderHeight();

    this.mobileMediaQuery.addEventListener(
      'change',
      this.setHeaderHeight
    );

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add(
        'shopify-section-header-sticky'
      );
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.predictiveSearches =
      this.querySelectorAll('predictive-search');

    this.onScrollHandler =
      this.onScroll.bind(this);

    this.hideHeaderOnScrollUp =
      () => (this.preventReveal = true);

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      false
    );

    this.createObserver();

  }

  setHeaderHeight() {

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );

  }

  disconnectedCallback() {

    this.mobileMediaQuery.removeEventListener(
      'change',
      this.setHeaderHeight
    );

    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

  }

  createObserver() {

    const observer =
      new IntersectionObserver(
        (entries, observerInstance) => {

          this.headerBounds =
            entries[0].intersectionRect;

          observerInstance.disconnect();

        }
      );

    observer.observe(this.header);

  }

  onScroll() {

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    if (
      [...this.predictiveSearches].some(
        predictiveSearch =>
          predictiveSearch.isOpen
      )
    ) {
      return;
    }

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {

      this.header.classList.add(
        'scrolled-past-header'
      );

      if (!this.headerIsAlwaysSticky) {

        requestAnimationFrame(
          this.hide.bind(this)
        );

      }

    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {

      this.header.classList.add(
        'scrolled-past-header'
      );

      if (!this.preventReveal) {

        requestAnimationFrame(
          this.reveal.bind(this)
        );

      }

    } else if (
      scrollTop <= this.headerBounds.top
    ) {

      this.header.classList.remove(
        'scrolled-past-header'
      );

      requestAnimationFrame(
        this.reset.bind(this)
      );

    }

    this.currentScrollTop = scrollTop;

  }

  hide() {

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this
      .querySelectorAll(
        '.xo-header__details[open]'
      )
      .forEach(
        details =>
          details.removeAttribute('open')
      );

    this.closeSearchModal();

  }

  reveal() {

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );

  }

  reset() {

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );

  }

  closeSearchModal() {

    this
      .querySelectorAll('details-modal')
      .forEach(
        searchModal =>
          searchModal.close(false)
      );

  }

}

if (!customElements.get('sticky-header')) {

  customElements.define(
    'sticky-header',
    StickyHeader
  );

}

document.addEventListener(
  'click',
  event => {

    document
      .querySelectorAll(
        '.xo-header__details[open]'
      )
      .forEach(details => {

        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }

      });

  }
);


  } catch(e) { console.error(e); }
})();
})();
